import { render, staticRenderFns } from "./MyMessagesIndex.vue?vue&type=template&id=d17d368e&"
import script from "./MyMessagesIndex.vue?vue&type=script&lang=js&"
export * from "./MyMessagesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports